import { render, staticRenderFns } from "./cCarroDispath.vue?vue&type=template&id=37c9f559&scoped=true"
import script from "./cCarroDispath.vue?vue&type=script&lang=js"
export * from "./cCarroDispath.vue?vue&type=script&lang=js"
import style0 from "./cCarroDispath.vue?vue&type=style&index=0&id=37c9f559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9f559",
  null
  
)

export default component.exports